<template>
    <v-dialog v-model="dialog"
              persistent
              max-width="290"
              v-on:keyup.enter="onEnter"
              v-on:keyup.esc="onEscape">
        <!--<template v-slot:activator="{ on, attrs }">
            <v-icon 
                color="black" 
                v-model="dialog"
                v-bind="attrs"
                v-on="on">
                mdi-delete
            </v-icon>

        </template>-->
        <v-card>
            <v-card-title class="headline">
                {{headline}}
            </v-card-title>
            <v-card-text>{{message}}</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1"
                       text
                       @click="dialog = false; onAccept(item, false);">
                    Cancel
                </v-btn>
                <v-btn color="green darken-1"
                       text
                       @click="dialog = false; onAccept(item, true);">
                    OK
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</template>
<script>
    export default {
        props: ["headline","message", "item", "onAccept", "dialogProxy"],
        data: () => { 
            return {
                dialog: false,
            }
        },
        watch: {
            dialogProxy: {
                handler() {
                    this.dialog = this.dialogProxy;
                }
            }
        },
        methods: {
            onEnter() {},
            onEscape() {}           
        },
        computed: {}
    }
</script>
